const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function buildAbsoluteApiUrl(path) {
    const base = (API_BASE || window.location.origin).replace(/\/+$/, "");
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${base}${cleanPath}`;
}

export function openCompanyScreenshotPrint(company) {
    if (!company?.id) return;

    const title = `Live Ansicht Screenshot - ${company.name || `Firma ${company.id}`}`;
    const params = new URLSearchParams({
        t: String(Date.now()),
        frontend_base: window.location.origin,
    });
    const imageUrl = buildAbsoluteApiUrl(`/api/companies/${company.id}/screenshot?${params.toString()}`);
    const win = window.open("", "_blank");

    if (!win) {
        window.open(imageUrl, "_blank", "noopener,noreferrer");
        return;
    }

    win.document.open();
    win.document.write(`
        <!doctype html>
        <html>
            <head>
                <meta charset="utf-8" />
                <title>${title.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</title>
                <style>
                    html, body {
                        margin: 0;
                        padding: 0;
                        background: #f3f4f6;
                        font-family: Arial, sans-serif;
                    }
                    .toolbar {
                        position: sticky;
                        top: 0;
                        display: flex;
                        gap: 8px;
                        justify-content: flex-end;
                        padding: 12px;
                        background: #fff;
                        border-bottom: 1px solid #ddd;
                    }
                    button {
                        border: 0;
                        border-radius: 6px;
                        padding: 9px 14px;
                        cursor: pointer;
                        font-weight: 700;
                    }
                    .print {
                        color: #fff;
                        background: #f28c18;
                    }
                    .image-wrap {
                        max-width: 1440px;
                        margin: 0 auto;
                        background: #fff;
                    }
                    img {
                        display: block;
                        width: 100%;
                        height: auto;
                    }
                    .error {
                        display: none;
                        margin: 32px auto;
                        max-width: 720px;
                        padding: 18px;
                        border: 1px solid #fecaca;
                        border-radius: 8px;
                        color: #991b1b;
                        background: #fef2f2;
                    }
                    @media print {
                        @page { margin: 8mm; }
                        body { background: #fff; }
                        .toolbar { display: none; }
                        .image-wrap { max-width: none; }
                    }
                </style>
            </head>
            <body>
                <div class="toolbar">
                    <button onclick="window.close()">Schließen</button>
                    <button class="print" onclick="window.print()">Drucken</button>
                </div>
                <div class="image-wrap">
                    <img
                        src="${imageUrl}"
                        alt="${title.replace(/"/g, "&quot;")}"
                        onload="setTimeout(function(){ window.print(); }, 250)"
                        onerror="document.querySelector('.error').style.display='block'; this.style.display='none';"
                    />
                </div>
                <div class="error">
                    Screenshot konnte nicht geladen werden. Bitte prüfen, ob Backend und Frontend lokal erreichbar sind.
                </div>
            </body>
        </html>
    `);
    win.document.close();
}
